import './ClinicalTrainingSection.css';

const ClinicalTrainingSection = () => {
  return (
    <section
      className="clinical-training section section--lg"
      aria-labelledby="clinical-training-heading"
    >
      <div className="container">
        <header className="section-header clinical-training__header">
          <p className="clinical-training__eyebrow">Formación</p>
          <h2 id="clinical-training-heading" className="section-title clinical-training__title">
            Formación clínica en alineadores basada en{' '}
            <span className="clinical-training__title-accent">experiencia real</span>
          </h2>
        </header>

        <div className="clinical-training__body">
          <div className="clinical-training__column clinical-training__column--main">
            <p>
              El sistema Always Aligners fue desarrollado por la Dra. Patricia Tarquini junto a su
              equipo clínico, integrando diagnóstico, planificación digital y biomecánica aplicada
              para el tratamiento con alineadores.
            </p>
            <p>
              Nuestro objetivo es acompañar a los profesionales en la incorporación de alineadores
              dentro de su práctica diaria, combinando conocimiento teórico con experiencia clínica
              real.
            </p>
            <p>
              Más que cursos, ofrecemos un sistema de trabajo, donde el profesional puede aprender,
              discutir casos y aplicar inmediatamente lo aprendido en su consulta.
            </p>
          </div>

          <aside className="clinical-training__highlight" aria-label="Mensaje destacado">
            <p className="clinical-training__highlight-text">
              Aprendé alineadores con quienes los usan todos los días
            </p>
          </aside>

          <div className="clinical-training__column clinical-training__column--closing">
            <p>
              El equipo de Always Aligners, liderado por la Dra. Patricia Tarquini, desarrolla y
              aplica un sistema clínico basado en diagnóstico, planificación digital y biomecánica
              para tratamientos con alineadores.
            </p>
            <p className="clinical-training__closing">
              Formamos profesionales que quieren integrar alineadores a su práctica con criterio
              clínico y resultados predecibles.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClinicalTrainingSection;
